import Model, { attr } from '@ember-data/model';
import { eflexFeatures } from 'cpc-license-manager/constants/eflex-features';

class Feature extends Model {
  @attr('string') key;
  @attr('string') group;
  @attr('boolean', { defaultValue: true }) enabled;

  get label() {
    return eflexFeatures.find(el => el.key === this.key)?.label;
  }
}

export default Feature;
